
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./input.css";
import { BrowserRouter } from "react-router-dom";
import { ClubsProvider } from "./components/Clubs/ClubsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ClubsProvider>
        <App />
      </ClubsProvider>
    </BrowserRouter>
  </React.StrictMode>
);
